// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "./Base"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("./Base"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Base);
    global.Primary = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Base) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.PrimaryButton = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var PrimaryButton = _exports.PrimaryButton = function PrimaryButton(props) {
    return /*#__PURE__*/_react["default"].createElement(_Base.BaseButton, _extends({
      className: ['cop-bg-[#212B36]', 'cop-text-white', 'cop-border-0', 'cop-shadow-none'].join(' ')
    }, props));
  };
});
